export default __webpack_public_path__ + "static/media/hero.5e5a966b.png";